import { FC } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Path } from '../../../routing';
import { settingsSidebarStateAtom, wearableErrorSnackBarAtom } from '../../../data-access';
import { ReactComponent as WatchIcon } from '../../../assets/tabs/settings-tab/watch-icon.svg';
import StyledSnackBar from './StyledSnackBar';

const WearableErrorSnackBar: FC = () => {
  const { t } = useTranslation();
  const [wearableErrorSnackbar, setWearableErrorSnackbar] =
    useRecoilState(wearableErrorSnackBarAtom);
  const setSettingsSidebarState = useSetRecoilState(settingsSidebarStateAtom);
  const navigate = useNavigate();

  const handleClose = () => setWearableErrorSnackbar(null);

  const handleReconnect = () => {
    setSettingsSidebarState({
      selectedParentKey: 'wearables',
      expandedParentKeys: [],
    });
    navigate(`${Path.HOME}/settings`);
  };

  return (
    <StyledSnackBar
      open={!!wearableErrorSnackbar}
      message={wearableErrorSnackbar?.message}
      icon={<WatchIcon />}
      color="#c0392b"
      actionLabel={
        wearableErrorSnackbar?.status === 401 ? t('settings.common.reconnect') : undefined
      }
      onAction={wearableErrorSnackbar?.status === 401 ? handleReconnect : undefined}
      onClose={handleClose}
      autoHideDuration={null}
      closeAriaLabel={t('data.common.close')}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    />
  );
};

export default WearableErrorSnackBar;
